import React from "react";

import ChooseCountry from "../assets/select_country.svg";
import Couple from "../assets/couple.svg";
import SendMoney from "../assets/send_money.svg";
import { IoChevronForwardOutline } from "react-icons/io5";

function HowItWorks(props) {
  return (
    <div className="mb-5 mt-5">
      <div className="row">
        <div className="col-12 col-md-5 col-lg-4">
          <div className="border-right-md mb-4 full-height">
            <h4 className="fs-1">How it works?</h4>
            <p>Here is simply 3 steps to send money.</p>
          </div>
        </div>
        <div className="col-12 col-md-7 col-lg-8">
          <div className="d-flex justify-content-between ps-md-3">
            <div className="d-flex flex-column align-items-center">
              <img
                src={ChooseCountry}
                alt="Choose country"
                className="d-block max-width-64-c mb-3"
              />
              <h4 className="font-18-12 text-center">Choose country</h4>
            </div>
            <div
              className="d-flex align-items-center text-gray-400 fs-34"
              style={{ minWidth: "30px" }}
            >
              <IoChevronForwardOutline />
            </div>
            <div className="d-flex flex-column align-items-center">
              <img
                src={Couple}
                alt="Add Recipient"
                className="d-block max-width-64-c mb-3"
              />
              <h4 className="font-18-12 text-center">Add Recipient</h4>
            </div>
            <div
              className="d-flex align-items-center text-gray-400 fs-34"
              style={{ minWidth: "30px" }}
            >
              <IoChevronForwardOutline />
            </div>
            <div className="d-flex flex-column align-items-center">
              <img
                src={SendMoney}
                alt="Send Money"
                className="d-block max-width-64-c mb-3"
              />
              <h4 className="font-18-12 text-center">Send Money</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowItWorks;
